var angular = require("angular");
var utils = require("./utils");
var _ = require("underscore");
var types = utils.types;

angular.module("app.directives").directive("questionAnswer", function() {
  return {
    template: require("./answer.pug"),
    scope: {
      question: "="
    },
    link: function(scope, el, attrs) {
      var $type = scope.question.$type;
      var type = scope.question.type = types[$type];

      if (type == "Date") {
        if (scope.question.date && scope.question.date.d)
          scope.question.date = new Date(scope.question.d.year + "-" + scope.question.d.month + "-" + scope.question.d.day + "T00:00:00Z");
      }

      if (type == "Document Upload") {
        if (!scope.question.fileName) return;
        var filenameParts = scope.question.fileName.split(".");
        var fileType = filenameParts[filenameParts.length - 1].toLowerCase();
        if (fileType.match(/(jpg|jpeg|png|gif)$/)) {
          scope.question.isPicture = true;
        }
      }

      if(type == 'TotalsTable'){
        scope.tableTotal = 0;
        var qdata = scope.question.data;
        if(qdata.length > 0){
          _.each(qdata, function (row) {
            scope.tableTotal += parseFloat(row[1]);
          });
        }
      }
    }
  };
});
